
import { Link } from 'react-router-dom'

export default function HashtagComponent({ decoratedText, children, readOnly }) {
    return (readOnly ?
        // don't add space before/after {children} it will break draft
        <Link className='hover-underline' to={`/hashtag/${decoratedText.replace(/#|＃/, '')}`}>{children}</Link> :
        <span className='hover-underline text-primary'>{children}</span>
    )
}